import { useRef } from "react";

interface PositionStyle {
  left?: number | string;
  right?: number | string;
  [key: string]: number | string | undefined;
}

interface UsePositionFilterReturn {
  getPosition: () => PositionStyle;
  popupRef: React.RefObject<HTMLDivElement | null>;
  buttonRef: React.RefObject<HTMLButtonElement | null>;
}

const usePositionFilter = (): UsePositionFilterReturn => {
  const popupRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const getPosition = (): PositionStyle => {
    if (popupRef.current && buttonRef.current) {
      // Clone the element
      const element = popupRef.current;
      const clone = element.cloneNode(true) as HTMLDivElement;
      clone.style.cssText = `
      position: absolute;
      visibility: hidden;
      display: block;
      left: -9999px;
    `;
      document.body.appendChild(clone);

      // Get the element's dimensions
      const { clientWidth: popupWidth } = clone;

      // Remove the clone
      document.body.removeChild(clone);

      const windowWidth = window.innerWidth;
      const { left: buttonX } = buttonRef.current.getBoundingClientRect();
      if (buttonX + popupWidth <= windowWidth) {
        return {
          left: 0,
        };
      } else if (windowWidth <= 360) {
        return {
          left: 0,
          right: 0,
        };
      } else {
        // show popup to the left of the button
        return {
          left: "unset",
          right: 0,
        };
      }
    }
    return {};
  };

  return { getPosition, popupRef, buttonRef };
};

export default usePositionFilter;
